import ManagePermissionsModal from './ManagePermissionsModal';
export default ManagePermissionsModal; 